import React, {useEffect, useState, useCallback} from "react";
import {createUseStyles, useTheme} from "react-jss";
import TabNav from "@artibulles-cis/react/TabNav";

import TimeSheetsTable from "./TimeSheetsTable";
// import InvoicesTableBySupplier from "./Tables/InvoicesTableBySupplier";

//eslint-disable-next-line
const styles = createUseStyles((theme) => ({
    ClassExtendTabNavLink: {
        borderRight: "1px solid rgb(220 220 220)",
    },
}));

const Component = React.memo(function Component(props) {
    //eslint-disable-next-line
    const theme = useTheme();
    //eslint-disable-next-line
    const classes = styles({...props, theme});

    /***************** REFS ******************/

    /***************** REFS ******************/

    /***************** CONST ******************/

    /***************** CONST ******************/

    /***************** STATE ******************/

    /***************** STATE ******************/

    /***************** CALLBACK ******************/

    /***************** CALLBACK ******************/

    /***************** EFFECTS ******************/

    /***************** EFFECTS ******************/

    /***************** FUNCTIONS ******************/

    /***************** FUNCTIONS ******************/

    /***************** RENDER ******************/

    return (
        <TabNav
            MainSlug={`/tasktimemanagement/times/alltimeentries`}
            DefaultTab={`/tasktimemanagement/times/alltimeentries/all`}
            ClassExtendTabNavLink={classes.ClassExtendTabNavLink}
            TabNavMenuHeight="30px"
            ActiveIndicator={{
                WithIndicator: true,
                Position: "Bottom",
            }}
            TabMenuContent={[
                {
                    TabMenu: (
                        <div className={classes.TabMenuDiv}>
                            <div className={classes.TabTitle}>All Entries</div>
                        </div>
                    ),
                    Slug: `/tasktimemanagement/times/alltimeentries/all`,
                    ShowOnlyIfActive: false,
                    exact: true,
                    TabContent: <TimeSheetsTable />,
                },
                {
                    TabMenu: (
                        <div className={classes.TabMenuDiv}>
                            <div className={classes.TabTitle}>By Customer</div>
                        </div>
                    ),
                    Slug: `/tasktimemanagement/times/alltimeentries/bycustomer`,
                    ShowOnlyIfActive: false,
                    exact: true,
                    TabContent: <TimeSheetsTable />,
                },
            ]}
        />
    );

    /***************** RENDER ******************/
});

export default Component;
